import Axios from 'axios'
import Moment from 'moment'

const microbiology = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.REPORT_RESULTS_BASE_URL
    return AxiosInstance
  },

  searchMicrobiologyResults(filters) {
    const params = {}

    if (filters.orderId) params.orderId = filters.orderId
    if (filters.patientName) params.patientName = filters.patientName
    if (filters.examName) params.examName = filters.examName
    if (filters.materialName) params.materialName = filters.materialName

    if (filters.startDate)
      params.registrationDateStart = Moment(filters.startDate, 'DD/MM/YYYY').format(
        'YYYY-MM-DD'
      )
    if (filters.endDate)
      params.registrationDateEnd = Moment(filters.endDate, 'DD/MM/YYYY').format(
        'YYYY-MM-DD'
      )

    if (filters.collectionStartDate)
      params.collectionDateStart = Moment(
        filters.collectionStartDate,
        'DD/MM/YYYY'
      ).format('YYYY-MM-DD')
    if (filters.collectionEndDate)
      params.collectionDateEnd = Moment(filters.collectionEndDate, 'DD/MM/YYYY').format(
        'YYYY-MM-DD'
      )

    params.page = filters.page || 0
    params.size = filters.size || 20
    params.sort = filters.sort || 'desc'
    params.sortBy = filters.sortBy || 'registrationDate'

    return this.axios().get('/solicitations', { params })
  },

  downloadMicrobiologyReport(orderId) {
    return this.axios().get(`/solicitations/${orderId}/report`, {
      responseType: 'arraybuffer',
    })
  },
}

export default microbiology
